module.exports = __webpack_public_path__ + "img/2020pigc.1c5d9140.png";